import styles from "../../Styles/statistic-circle.module.css";

interface StatisticCircleProps {
  value: number | string;
  color?: string;
  size?: "sm" | "md" | "lg";
  suffix?: string;
  progress?: number; // Progress percentage (0-100)
  maxValue?: number; // Maximum value for auto-calculating progress
}

export default function StatisticCircle({
  value,
  color = "#A3C86D",
  size = "md",
  suffix = "",
  progress,
  maxValue,
}: StatisticCircleProps) {
  // Calculate progress percentage - use the value directly as percentage
  let progressPercentage = 0;
  if (progress !== undefined) {
    progressPercentage = Math.min(Math.max(progress, 0), 100);
  } else if (maxValue && typeof value === "number") {
    progressPercentage = Math.min(Math.max((value / maxValue) * 100, 0), 100);
  } else if (typeof value === "number") {
    // Use the value directly as percentage (0-100)
    progressPercentage = Math.min(Math.max(value, 0), 100);
  } else if (typeof value === "string") {
    // Try to parse string values (like "67.7")
    const numValue = Number.parseFloat(value);
    if (!isNaN(numValue)) {
      progressPercentage = Math.min(Math.max(numValue, 0), 100);
    }
  }

  // SVG circle properties
  const sizes = {
    sm: { radius: 32, strokeWidth: 3, size: 80 },
    md: { radius: 48, strokeWidth: 4, size: 112 },
    lg: { radius: 62, strokeWidth: 5, size: 144 },
  };

  const { radius, strokeWidth, size: svgSize } = sizes[size] || sizes.md;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset =
    circumference - (progressPercentage / 100) * circumference;

  const sizeClass = styles[size] || styles.md;
  return (
    <div className={`${styles.circle} ${sizeClass}`}>
      <svg
        className={styles.progressSvg}
        width={svgSize}
        height={svgSize}
        viewBox={`0 0 ${svgSize} ${svgSize}`}
      >
        {/* Background circle */}
        <circle
          cx={svgSize / 2}
          cy={svgSize / 2}
          r={radius}
          fill="none"
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
        />
        {/* Progress circle */}
        <circle
          cx={svgSize / 2}
          cy={svgSize / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className={styles.progressCircle}
          transform={`rotate(-90 ${svgSize / 2} ${svgSize / 2})`}
        />
      </svg>
      <div
        className={styles.indicator}
        style={{ backgroundColor: color }}
      ></div>
      <span className={styles.value}>
        {value ?? 0}
        {suffix}
      </span>
    </div>
  );
  // return (
  //   <div className={`${styles.circle} ${sizeClass}`} style={{ borderColor: color }}>
  //     <div className={styles.indicator} style={{ backgroundColor: color }}></div>
  //     <span className={styles.value}>
  //       {value}
  //       {suffix}
  //     </span>
  //   </div>
  // );
}
